import PropTypes from 'prop-types'

import placeholderFactory from './factory'

export default placeholderFactory('AcpFilterGroup', {
  title: PropTypes.string,
  maxWidth: PropTypes.bool,
  isBreak: PropTypes.bool,
})
